import { render, staticRenderFns } from "./SideLayout.vue?vue&type=template&id=bc39ca38&scoped=true"
import script from "./SideLayout.vue?vue&type=script&lang=ts"
export * from "./SideLayout.vue?vue&type=script&lang=ts"
import style0 from "./SideLayout.vue?vue&type=style&index=0&id=bc39ca38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc39ca38",
  null
  
)

export default component.exports